import React, { useEffect, useRef, useState } from "react";
import "./index.scss";
import ChatContent from "../../components/chat/chat-content";
import ChatDetail from "./detail";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import * as _ from "lodash";
import * as Moment from "moment";
import Picker from "@emoji-mart/react";
import data from "@emoji-mart/data";
import {
  queryMessageBySessionId,
  sendMessage,
} from "../../store/message/thunkAction";
import { messageAction } from "../../store/message/slice";
import { socketActions } from "../../store/socket/slice";
import { useNavigate, useParams } from "react-router-dom";
import {
  convertTicket,
  editSession,
  readSession,
} from "../../store/session/thunkAction";
import {
  editRequester,
  readRequester,
} from "../../store/requester/thunkAction";
import Popup from "../../components/core/popup";
import { listProfileShorthandByProfileId } from "../../store/profile-shorthand/thunkAction";
import { readProfileRouterByProfileId } from "../../store/profile-router/thunkAction";
import Dropdown from "../../components/core/dropdown";
import { SessionStatus } from "../../constant/enums";
import {
  goToTicket,
  sendNotifyChatSuccess,
  sendNotifyChatError,
} from "../../utils/event";
import { listGroup } from "../../store/group/thunkAction";
import {
  listStaffByGroupId,
  listStaffOnline,
} from "../../store/staff/thunkAction";
import { SessionAction } from "../../store/session/slice";
import { readProfileFormByProfileId } from "../../store/profile-form/thunkAction";
import { getImageUrl } from "../../utils/image";
import { noteAction } from "../../store/note/slice";
import { attachmentAction } from "../../store/attachment/slice";
import { readProfileByDomain } from "../../store/profile/thunkAction";

const MAX_FILE_SIZE = 3 * 1024 * 1024;
const ACCEPTED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/pdf",
  "text/plain",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

const ChatPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const chatId = _.get(params, "id");
  const sessionId = _.get(params, "sessionId");
  const dispatch = useDispatch();
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [image, setImage] = useState(null);
  const [isImage, setIsImage] = useState(false);
  const [fileType, setFileType] = useState("default");
  const [messageGroup, setMessageGroup] = useState({});
  const fileInputRef = useRef(null);
  const bottomRef = useRef(null);
  const [isOpenShortMessage, setIsOpenShortMessage] = useState(false);
  const [isOpenConvertTicket, setIsOpenConvertTicket] = useState(false);
  const [isOpenAddStaff, setIsOpenAddStaff] = useState(false);
  const [isOpenBockRequester, setIsOpenBockRequester] = useState(false);
  const [isOpenServedSession, setIsOpenServedSession] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
  const [groups, setGroups] = useState([]);
  const [groupId, setGroupId] = useState(null);
  const [isActiveRouter, setIsActiveRouter] = useState(false);
  const [groupDefaultId, setGroupDefaultId] = useState(null);
  const chatInputBoxRef = useRef(null);
  const [agents, setAgents] = useState([]);
  const [agentId, setAgentId] = useState(null);
  const [statusSession, setStatusSession] = useState(SessionStatus.PENDING);
  const [isBlockRequester, setIsBlockRequester] = useState(false);
  const [sessionTicketId, setSessionTicketId] = useState(null);
  const [isOutSession, setIsOutSession] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
  const buttonEmojiRef = useRef(null);
  const pickerRef = useRef(null);
  const [isAllowedChat, setAllowedChat] = useState(false);
  const [replyMessage, setReplyMessage] = useState(null);
  const [replyName, setReplyName] = useState("");
  const [replyMessageId, setReplyMessageId] = useState(null);
  const replyMessageRef = useRef(null);

  const requesterManage = useSelector((state) => state.requesterManage);
  const socketManage = useSelector((state) => state.socketManage);
  const sessionManage = useSelector((state) => state.sessionManage);
  const messageManage = useSelector((state) => state.messageManage);
  const staffManage = useSelector((state) => state.staffManage);
  const profileManage = useSelector((state) => state.profileManage);
  const groupManage = useSelector((state) => state.groupManage);
  const attachmentManage = useSelector((state) => state.attachmentManage);

  const attachments = _.get(attachmentManage, "attachments", {});
  const profile = _.get(profileManage, "profile");
  const profileShorthandManage = useSelector(
    (state) => state.profileShorthandManage
  );
  const profileRouterManage = useSelector((state) => state.profileRouterManage);
  const profileRouter = _.get(profileRouterManage, "profileRouter");
  const profileShorthands = _.get(
    profileShorthandManage,
    "profileShorthands",
    []
  );
  const staff = _.get(staffManage, "staff", {});
  const staffId = _.get(staff, "_id");
  const staffs = _.get(staffManage, "staffs", {});
  const groupsAccount = _.get(groupManage, "groups", []);
  const staffGroups = _.get(staffManage, "staffGroups", []);
  const staffOnline = _.get(staffManage, "listStaffOnline", []);
  const requester = _.get(requesterManage, "requester");
  const socketMessage = _.get(socketManage, "message");
  const isConnected = _.get(socketManage, "isConnected");
  const requesterTrackingChange = _.get(
    socketManage,
    "requesterTrackingChange"
  );
  const sessionConvertTicket = _.get(socketManage, "sessionConvertTicket");
  const sessionSeen = _.get(socketManage, "sessionSeen");
  const staffStatus = _.get(socketManage, "staffStatus");
  const session = _.get(sessionManage, "session");
  const requesterSeenAt = _.get(session, "requesterSeenAt", 0);
  const messages = _.get(messageManage, "messages", []);
  const lastMessageStaff = _.last(
    _.filter(messages, (message) => message.staffId === staffId)
  );
  const lastMessageRequesterSeen = _.last(
    _.filter(
      messages,
      (message) =>
        message.addTime <= requesterSeenAt && message.staffId === staffId
    )
  );
  const lastMessageId = _.get(lastMessageStaff, "_id");
  const lastMessageSeenId = _.get(lastMessageRequesterSeen, "_id");
  const skipMessage = _.get(messageManage, "skip", 0);
  const limitMessage = _.get(messageManage, "limit", 10);
  const totalMessage = _.get(messageManage, "total", 0);
  const isLoadingSendMessage = _.get(
    messageManage,
    "isLoadingSendMessage",
    false
  );
  const isLoadingQueryMessage = _.get(
    messageManage,
    "isLoadingQueryMessage",
    false
  );
  const requesterId = _.get(requester, "_id");

  const mapConfigAgent = {
    id: "_id",
    name: "name",
  };

  useEffect(() => {
    if (session.domain) {
      dispatch(readProfileByDomain(session.domain));
    }
  }, [dispatch, session.domain]);

  useEffect(() => {
    if (sessionConvertTicket) {
      const covertSessionId = _.get(sessionConvertTicket, "_id");
      if (covertSessionId && sessionId && sessionId === covertSessionId) {
        dispatch(readSession(sessionId));
        dispatch(SessionAction.clearSessionById(sessionId));
        sendNotifyChatSuccess(t("session.convert_ticket_success"));
      }
      dispatch(socketActions.clearSessionCovertTicket());
    }
  }, [sessionConvertTicket, dispatch, sessionId, t]);

  useEffect(() => {
    if (sessionSeen) {
      const sessionSeenId = _.get(sessionSeen, "_id");
      if (sessionSeenId && sessionId && sessionId === sessionSeenId) {
        dispatch(readSession(sessionId));
      }
      dispatch(socketActions.clearSessionSeen());
    }
  }, [sessionSeen, dispatch, sessionId, t]);

  useEffect(() => {
    if (staffStatus) {
      dispatch(listStaffOnline());
    }
  }, [dispatch, staffStatus]);

  useEffect(() => {
    const staffId = _.get(staff, "_id");
    const otherStaffIds = _.get(session, "otherStaffIds", []);

    const getFilteredAgents = (list) => {
      return _.reject(_.values(list), (agent) => {
        const agentId = _.get(agent, "_id");
        return agentId === staffId || _.includes(otherStaffIds, agentId);
      });
    };

    if (groupId) {
      setAgents(getFilteredAgents(staffGroups));

      return;
    } else {
      setAgents(getFilteredAgents(staffOnline));
    }
  }, [staff, session, staffGroups, groupId, staffOnline]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target) &&
        buttonEmojiRef.current &&
        !buttonEmojiRef.current.contains(event.target)
      ) {
        setShowPicker(false);
      }
    };

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showPicker]);

  useEffect(() => {
    if (groupId) {
      dispatch(listStaffByGroupId(groupId));
    }
  }, [groupId, dispatch]);

  useEffect(() => {
    dispatch(messageAction.clearMessage());
    dispatch(noteAction.clearNote());
    dispatch(attachmentAction.clearAttachment());
    dispatch(readSession(sessionId));
    dispatch(messageAction.setSessionId(sessionId));
    setText("");
    setFile(null);
    setImage(null);
    setReplyMessage(null);
    setReplyMessageId(null);
  }, [sessionId, dispatch]);

  useEffect(() => {
    if (sessionId && staffId) {
      dispatch(
        editSession({
          id: sessionId,
          data: {
            staffSeenDetail: [
              {
                staffId,
                seenAt: +Moment.utc(),
              },
            ],
          },
        })
      );
    }
  }, [sessionId, staffId, dispatch]);

  useEffect(() => {
    const sessionId = _.get(session, "_id");
    const sessionStaffId = _.get(session, "staffId");
    const sessionOtherStaffId = _.get(session, "otherStaffIds", []);
    const staffId = _.get(staff, "_id");

    if (sessionId && staffId) {
      setAllowedChat(
        sessionStaffId === staffId || _.includes(sessionOtherStaffId, staffId)
      );
    }
  }, [session, staff]);

  useEffect(() => {
    const requesterChangeId = _.get(requesterTrackingChange, "requesterId");
    if (requesterChangeId && requesterChangeId === requesterId) {
      dispatch(readRequester(requesterId));
    }
  }, [requesterTrackingChange, requesterId, dispatch]);

  useEffect(() => {
    const requesterId = _.get(session, "requesterId");
    const status = _.get(session, "status", SessionStatus.PENDING);
    const ticketId = _.get(session, "ticketId", null);

    setStatusSession(status);
    setSessionTicketId(ticketId);

    if (requesterId) {
      dispatch(readRequester(requesterId));
    }
  }, [session, dispatch]);

  useEffect(() => {
    const profileId = _.get(profile, "_id");
    if (profileId) {
      dispatch(readProfileRouterByProfileId(profileId));
      dispatch(readProfileFormByProfileId(profileId));
    }
  }, [dispatch, profile]);

  useEffect(() => {
    const isBlocked = _.get(
      _.find(requester.attributes, { key: "isBlocked" }),
      "value",
      false
    );

    setIsBlockRequester(isBlocked);
  }, [requester]);

  useEffect(() => {
    const profileRouterId = _.get(profileRouter, "_id");
    const groups = _.get(profileRouter, "groups", []);
    const isActive = _.get(profileRouter, "isActive", false);
    const groupDefaultId = _.get(profileRouter, "groupDefaultId", null);

    if (!isActive && !groupDefaultId) {
      dispatch(listGroup());
    }

    if (profileRouterId) {
      setGroupDefaultId(groupDefaultId);
      setGroups(groups);
      setIsActiveRouter(isActive);
    }
  }, [profileRouter, dispatch]);

  useEffect(() => {
    let timeout;

    if (!isConnected) {
      dispatch(messageAction.clearMessage());
      return;
    }

    dispatch(
      queryMessageBySessionId({
        sessionId,
        filter: {
          skip: skipMessage,
          limit: limitMessage,
        },
      })
    );

    if (skipMessage === 0 && bottomRef.current) {
      timeout = setTimeout(() => {
        bottomRef.current.scrollIntoView({ behavior: "auto" });
      }, 1000);
    }

    return () => clearTimeout(timeout);
  }, [sessionId, dispatch, skipMessage, limitMessage, isConnected]);

  useEffect(() => {
    let timeout;

    if (skipMessage === 0 && bottomRef.current) {
      timeout = setTimeout(() => {
        bottomRef.current.scrollIntoView({ behavior: "auto" });
      }, 1000);
    }

    return () => clearTimeout(timeout);
  }, [messages, skipMessage]);

  useEffect(() => {
    if (!replyMessageId) {
      return;
    }

    if (isLoadingQueryMessage) {
      return;
    }

    const hasMessage = messages.some((msg) => msg._id === replyMessageId);

    if (hasMessage) {
      setReplyMessageId(null);
    } else {
      if (messages.length >= totalMessage) {
        return;
      }
      dispatch(messageAction.setSkip(messages.length));
    }

    setTimeout(() => {
      const el = document.getElementById(`message-${replyMessageId}`);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "center" });
        el.classList.add("highlight-reply");

        setTimeout(() => {
          el.classList.remove("highlight-reply");
        }, 2000);
      }
    }, 1000);
  }, [
    dispatch,
    replyMessageId,
    skipMessage,
    limitMessage,
    sessionId,
    totalMessage,
    messages,
    isLoadingQueryMessage,
  ]);

  useEffect(() => {
    if (socketMessage) {
      dispatch(messageAction.addMessage(socketMessage));
      dispatch(socketActions.clearMessage());

      if (socketMessage.sessionId === sessionId && staffId) {
        dispatch(
          editSession({
            id: sessionId,
            data: {
              staffSeenDetail: [
                {
                  staffId,
                  seenAt: +Moment.utc(),
                },
              ],
            },
          })
        );
      } else {
        dispatch(readSession(sessionId));
      }
    }
  }, [dispatch, socketMessage, sessionId, staffId]);

  useEffect(() => {
    const slashIndex = text.lastIndexOf("/");
    if (slashIndex !== -1) {
      const searchText = text.slice(slashIndex + 1);

      dispatch(
        listProfileShorthandByProfileId({
          profileId: profile._id,
          search: searchText.trim(),
        })
      );

      updatePopupPosition();
      setIsOpenShortMessage(true);
    } else {
      setIsOpenShortMessage(false);
    }
  }, [text, profile, dispatch]);

  const mapDropdownGroup = {
    id: "value",
    name: "key",
  };

  const mapDropdownGroupAccount = {
    id: "_id",
    name: "name",
  };

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleTogglePicker = () => {
    if (buttonEmojiRef.current) {
      const rect = buttonEmojiRef.current.getBoundingClientRect();
      setPickerPosition({
        top: rect.bottom + window.scrollY - 480,
        left: rect.left + window.scrollX - 350,
      });
    }
    setShowPicker(!showPicker);
  };

  const handleEmojiSelect = (emoji) => {
    if (!text.trim()) {
      setText(emoji.native);
    } else {
      setText(text + emoji.native);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const fileType = file.type;
    const fileSizeMB = file.size;

    if (!ACCEPTED_TYPES.includes(fileType)) {
      sendNotifyChatError(t("session.send_file_error"));
      return;
    }

    if (fileSizeMB > MAX_FILE_SIZE) {
      sendNotifyChatError(t("session.file_too_large"));
      return;
    }

    setFile(file);
    setIsImage(_.startsWith(_.get(file, "type", ""), "image"));
    setFileType(fileTypeIcon(file.name, file.type));
    const reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const closePopupShortMessage = () => {
    setIsOpenShortMessage(false);
  };

  const closePopupAddStaff = () => {
    setIsOpenAddStaff(false);
  };

  const closePopupConvertTicket = () => {
    setIsOpenConvertTicket(false);
  };

  const closePopupServedSession = () => {
    setIsOpenServedSession(false);
  };

  const closePopupBlockRequester = () => {
    setIsOpenBockRequester(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (event.shiftKey) {
        return;
      }

      const slashIndex = text.lastIndexOf("/");
      if (slashIndex === 0 && isOpenShortMessage) {
        const keyword = text.slice(1).trim().toLowerCase();

        const matchedItem = profileShorthands.find(
          (item) => item.key.toLowerCase() === keyword
        );

        if (matchedItem) {
          setText(matchedItem.text);
        }

        setIsOpenShortMessage(false);
        return;
      }
      event.preventDefault();
      sendStaffMessage();
    }
  };

  const groupMessageByDate = (messages) => {
    return _(messages)
      .groupBy((msg) => {
        const msgDate = Moment(msg.addTime);
        return msgDate.isSame(Moment(), "day")
          ? ""
          : msgDate.format("DD-MM-YYYY");
      })
      .value();
  };

  useEffect(() => {
    setMessageGroup(groupMessageByDate(messages));
  }, [messages]);

  const addStaffOtherSession = () => {
    const staffId = _.get(staff, "_id");
    const staffSessionId = _.get(session, "staffId");
    const otherStaffIds = _.get(session, "otherStaffIds", []);

    if (!agentId && !isOutSession) {
      return;
    }

    if (agentId) {
      const newStaffId =
        isOutSession && staffId === staffSessionId ? agentId : staffSessionId;
      const newOtherStaffIds = isOutSession
        ? _.uniq([...otherStaffIds, agentId])
        : _.without(_.uniq([...otherStaffIds, agentId]), staffId);

      const data = {
        staffId: newStaffId,
        otherStaffIds: newOtherStaffIds,
        handleStaffId: staffId,
      };

      if (groupId) {
        data["groupId"] = groupId;
      }

      dispatch(
        editSession({
          id: sessionId,
          data,
        })
      );
    } else {
      let newStaffId = staffSessionId;
      let newOtherStaffIds = [];

      if (staffId === staffSessionId) {
        newStaffId = otherStaffIds.length ? otherStaffIds[0] : null;
        newOtherStaffIds = newStaffId
          ? _.without(otherStaffIds, newStaffId, staffId)
          : [];
      } else {
        newOtherStaffIds = _.without(otherStaffIds, staffId);
      }

      if (!newStaffId && _.isEmpty(newOtherStaffIds)) {
        sendNotifyChatError(t("session.staff_is_required"));

        return;
      }

      const data = {
        staffId: newStaffId,
        otherStaffIds: newOtherStaffIds,
      };

      dispatch(
        editSession({
          id: sessionId,
          data,
        })
      );
    }

    if (isOutSession) {
      dispatch(SessionAction.clearSessionById(sessionId));
      navigate(`/chat/${chatId}`);
    }
  };

  const servedSession = () => {
    dispatch(
      editSession({
        id: sessionId,
        data: {
          status: SessionStatus.SERVED,
        },
      })
    );
  };

  const sendStaffMessage = async () => {
    let timeout;
    const accountId = _.get(staff, "accountId");
    const sessionId = _.get(session, "_id");
    const staffId = _.get(staff, "_id");
    const staffName = _.get(staff, "name");
    const status = _.get(session, "status");

    if (
      !sessionId ||
      _.includes([SessionStatus.CLOSED, SessionStatus.SERVED], status) ||
      isLoadingSendMessage
    ) {
      return;
    }

    if (!text.trim() && !file) {
      return;
    }

    const formData = new FormData();

    formData.append("accountId", accountId);
    formData.append("sessionId", sessionId);
    formData.append("staffId", staffId);
    formData.append("name", staffName);
    formData.append("content", text || "---");
    formData.append("type", file ? "FILE" : "TEXT");
    formData.append("addTime", +Moment.utc());
    formData.append("updateTime", +Moment.utc());

    if (file) {
      formData.append("file", file);
      formData.append("fileName", file.name);
    }

    if (replyMessage) {
      formData.append("replyMessageId", _.get(replyMessage, "_id"));
    }

    setText("");
    setFile(null);
    setImage(null);
    setReplyMessage(null);

    try {
      const result = await dispatch(
        sendMessage({ data: formData, isFormData: !!file })
      ).unwrap();

      const messageId = _.get(result, "_id");

      if (messageId) {
        dispatch(
          editSession({
            id: sessionId,
            data: {
              updateTime: +Moment.utc(),
              lastMessage: text || "",
              isRequesterLastMessage: false,
              staffSeenDetail: [
                {
                  staffId,
                  seenAt: +Moment.utc(),
                },
              ],
            },
          })
        );
      }
    } catch (error) {
      const errorCode = _.get(error, "errorCode");
      if (errorCode === "FILE_NOT_ALLOWED") {
        sendNotifyChatError(t("session.send_file_error"));
      } else if (errorCode === "FILE_TOO_LARGE") {
        sendNotifyChatError(t("session.file_too_large"));
      } else {
        sendNotifyChatError(t("session.send_message_error"));
      }
    }

    if (bottomRef.current) {
      timeout = setTimeout(() => {
        bottomRef.current.scrollIntoView({ behavior: "auto" });
      }, 800);
    }
    return () => clearTimeout(timeout);
  };

  const updatePopupPosition = () => {
    if (chatInputBoxRef.current) {
      const rect = chatInputBoxRef.current.getBoundingClientRect();
      setPopupPosition({
        top: rect.top - 230,
        left: rect.left,
        width: rect.width,
      });
    }
  };

  const handleOpenPopup = () => {
    updatePopupPosition();
    setIsOpenShortMessage(true);
  };

  const convertSessionToTicket = () => {
    const staffId = _.get(staff, "_id");
    if (!staffId) {
      return;
    }

    const data = {
      staffId,
    };

    dispatch(
      convertTicket({
        id: sessionId,
        data: data,
      })
    );

    sendNotifyChatSuccess(t("session.converting_ticket"));
    closePopupConvertTicket();
  };

  const blockRequester = () => {
    const requesterId = _.get(requester, "_id");

    if (!requesterId) {
      return;
    }

    dispatch(
      editRequester({
        id: requesterId,
        data: {
          attributes: [{ key: "isBlocked", value: true }],
        },
      })
    );
  };

  const unlockRequester = () => {
    const requesterId = _.get(requester, "_id");

    if (!requesterId) {
      return;
    }

    dispatch(
      editRequester({
        id: requesterId,
        data: {
          attributes: [{ key: "isBlocked", value: false }],
        },
      })
    );
  };

  useEffect(() => {
    window.addEventListener("resize", updatePopupPosition);
    window.addEventListener("scroll", updatePopupPosition);

    return () => {
      window.removeEventListener("resize", updatePopupPosition);
      window.removeEventListener("scroll", updatePopupPosition);
    };
  }, []);

  const fileTypeIcon = (name, type) => {
    const ext = name.split(".").pop()?.toLowerCase() || "";

    if (type.includes("pdf") || ext === "pdf") return "pdf";
    if (type.includes("word") || ["doc", "docx"].includes(ext)) return "word";
    if (type.includes("excel") || ["xls", "xlsx"].includes(ext)) return "excel";

    return "default";
  };

  const timeAgo = (timestamp) => {
    const now = Moment();
    const time = Moment(timestamp);

    if (time.isAfter(now)) {
      return time.from(now);
    }
    return time.fromNow();
  };

  const onReplyMessage = (message) => {
    const messageStaffId = _.get(message, "staffId");
    const requesterId = _.get(message, "requesterId");

    setReplyMessage(message);

    if (requesterId) {
      setReplyName(requester?.name || session?.name || "");
    }
    if (messageStaffId && staffId === messageStaffId) {
      setReplyName(t("agent.chat.your_message"));
    }
    if (messageStaffId && staffId !== messageStaffId) {
      setReplyName(staffs[messageStaffId]?.name || "");
    }
  };

  return (
    <div className="chat-content-box h-100">
      <div className="row g-0 h-100">
        <div className="col-md-8 h-100">
          <div className="chat-content position-relative d-flex flex-column justify-content-between h-100">
            <div className="h-60 px-3 d-flex border-bottom gap-2 justify-content-between align-items-center">
              <div>
                <div className="fw-semibold d-flex align-items-center gap-2">
                  <span className="text-nowrap">{session.name || ""}</span>{" "}
                  <span className="color-gray fs-4 lh-1 pb-1">•</span>{" "}
                  <span className="one-line">
                    {staffs[session.staffId]?.name || ""}
                    {(session.otherStaffIds || []).map((staffId) => {
                      if (staffId !== session.staffId) {
                        return (
                          <span key={staffId} className="color-gray">
                            , {staffs[staffId]?.name || ""}
                          </span>
                        );
                      }
                      return <span key={staffId}></span>;
                    })}
                  </span>
                </div>
                <div className="small color-info">
                  {session.status === SessionStatus.PENDING && (
                    <span className="btn btn-warning btn-sm">
                      {t("session.session_status.pending")}
                    </span>
                  )}
                  {session.status === SessionStatus.WAITING && (
                    <span className="btn btn-info-light btn-sm">
                      {t("session.session_status.waiting")}
                    </span>
                  )}
                  {session.status === SessionStatus.CLOSED && (
                    <span className="btn btn-gray-light  btn-sm">
                      {t("session.session_status.closed")}
                    </span>
                  )}
                  {session.status === SessionStatus.SERVED && (
                    <span className="btn btn-success-light btn-sm">
                      {t("session.session_status.served")}
                    </span>
                  )}
                  <span className="color-gray px-2">•</span>
                  <span className="color-gray">
                    {t("agent.chat.last_update")}: {timeAgo(session.updateTime)}
                  </span>
                </div>
              </div>
              {isAllowedChat && (
                <div className="d-flex align-items-center gap-1">
                  <button
                    className="p-2 chat-button"
                    onClick={() => {
                      if (sessionTicketId) {
                        goToTicket(sessionTicketId);
                        return;
                      }
                      setIsOpenConvertTicket(true);
                    }}
                  >
                    <img src="/img/chat/icon/ticket.svg" alt="" />
                  </button>
                  {statusSession !== SessionStatus.CLOSED && (
                    <button
                      className="p-2 chat-button"
                      onClick={() => {
                        setIsOutSession(false);
                        setAgentId(null);
                        setGroupId(null);
                        setIsOpenAddStaff(true);
                      }}
                    >
                      <img src="/img/chat/icon/add.svg" alt="" />
                    </button>
                  )}
                  {statusSession === SessionStatus.PENDING && (
                    <button
                      className="p-2 chat-button"
                      onClick={() => setIsOpenServedSession(true)}
                    >
                      <img
                        style={{ width: "18px", height: "20px" }}
                        src="/img/chat/icon/done.svg"
                        alt=""
                      />
                    </button>
                  )}
                  {!isBlockRequester && (
                    <button
                      className="p-2 chat-button"
                      onClick={() => setIsOpenBockRequester(true)}
                    >
                      <img src="/img/chat/icon/close.svg" alt="" />
                    </button>
                  )}
                  {isBlockRequester && (
                    <button
                      className="p-2 chat-button"
                      onClick={() => unlockRequester()}
                    >
                      <img
                        style={{ width: "18px", height: "20px" }}
                        src="/img/chat/icon/unlock.svg"
                        alt=""
                      />
                    </button>
                  )}
                </div>
              )}
            </div>
            <div className="chat-content-body">
              <div className="overflow-auto">
                <div className="chat-content-body-in justify-content-end d-flex flex-column gap-3 p-3">
                  {messages.length < totalMessage && (
                    <button
                      onClick={() => {
                        dispatch(messageAction.setSkip(messages.length));
                      }}
                      className="show-more-button btn-primary"
                    >
                      {t("agent.chat.show_more")}
                    </button>
                  )}
                  {_.keys(messageGroup).map((key) => {
                    const messages = _.uniqBy(messageGroup[key], "_id");
                    return (
                      <div key={key}>
                        {messages.map((message, index) => {
                          const nextMessage = messages[index + 1];

                          const isSameSender =
                            nextMessage &&
                            message.staffId === nextMessage.staffId &&
                            message.requesterId === nextMessage.requesterId;

                          const isWithin1Minute = nextMessage
                            ? Moment(nextMessage.addTime).diff(
                                Moment(message.addTime),
                                "minutes"
                              ) === 0
                            : false;

                          const isShowTime = !isSameSender || !isWithin1Minute;

                          return (
                            <div
                              key={message._id}
                              id={`message-${message._id}`}
                              ref={(el) => {
                                if (message._id === replyMessageId) {
                                  replyMessageRef.current = el;
                                }
                              }}
                            >
                              <ChatContent
                                message={message}
                                config={{
                                  onReplyMessage,
                                  isLastMessage: lastMessageId === message._id,
                                  isSeen: lastMessageSeenId === message._id,
                                  isShowTime,
                                  setReplyMessageId,
                                }}
                              />
                            </div>
                          );
                        })}
                        <div className="color-gray date text-center">{key}</div>
                      </div>
                    );
                  })}
                  <div ref={bottomRef} />
                </div>
              </div>
            </div>
            {statusSession === SessionStatus.PENDING &&
              !isBlockRequester &&
              isAllowedChat && (
                <div className="h-60 px-3 d-flex gap-2 justify-content-between align-items-center position-relative">
                  <div
                    className="chat-input-action-box px-3"
                    style={{
                      display: _.get(replyMessage, "_id") ? "block" : "none",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                      className="chat-input-action-reply bg-gray-light gap-2 p-1 px-2 rounded-2"
                    >
                      <div
                        style={{
                          width: "90%",
                        }}
                      >
                        <div className="one-line">
                          <strong>
                            {t("agent.chat.reply")}
                            {replyName ? ` ${replyName}` : ""}:
                          </strong>{" "}
                          {_.get(replyMessage, "content", "")}
                        </div>
                        {(
                          attachments[_.get(replyMessage, "_id", "")] || []
                        ).map((attachment, index) => {
                          const url = getImageUrl(_.get(attachment, "url", ""));
                          const name = _.get(attachment, "name", "");
                          const type = _.get(attachment, "type", "");
                          const isImage = _.startsWith(type, "image");
                          const iconType = fileTypeIcon(name, type);
                          return (
                            <div
                              key={index}
                              className="chat-mess-attachment mt-2"
                            >
                              {isImage && (
                                <img
                                  src={url}
                                  alt={name}
                                  className="chat-attachment-image rounded"
                                  style={{
                                    maxWidth: "70px",
                                    maxHeight: "50px",
                                  }}
                                />
                              )}
                              {!isImage && (
                                <div className="chat-mess-text d-flex gap-2 align-items-center">
                                  {iconType === "pdf" && (
                                    <img
                                      src="/img/chat/icon/pdf.svg"
                                      alt="pdf"
                                      width={18}
                                    />
                                  )}
                                  {iconType === "word" && (
                                    <img
                                      src="/img/chat/icon/word.svg"
                                      alt="word"
                                      width={18}
                                    />
                                  )}
                                  {iconType === "excel" && (
                                    <img
                                      src="/img/chat/icon/excel.svg"
                                      alt="excel"
                                      width={18}
                                    />
                                  )}
                                  {iconType === "default" && (
                                    <svg
                                      className="icon"
                                      width="15"
                                      height="18"
                                      viewBox="0 0 15 18"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                        fill="#211F26"
                                      />
                                    </svg>
                                  )}
                                  <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={url}
                                    style={{
                                      maxWidth: "160px",
                                      color: "#212529",
                                      direction: "rtl",
                                      textAlign: "left",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                    className="ellipsis-start"
                                  >
                                    {name}
                                  </a>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                      <button
                        onClick={() => setReplyMessage(null)}
                        className="chat-input-action-reply-close"
                        style={{
                          background: "none",
                          border: "none",
                        }}
                      >
                        <img src="/img/chat/icon/x.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <div className="chat-input-box position-relative w-100">
                    <textarea
                      className="form-control chat-input-mess h-40 bg-gray-light border-0"
                      placeholder={t("agent.chat.write_message")}
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                      onKeyDown={handleKeyDown}
                      ref={chatInputBoxRef}
                      style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        width: "80%",
                      }}
                    />
                    <div
                      className="d-flex gap-2 pe-3 align-items-center position-absolute top-0 end-0"
                      style={{
                        backgroundColor: "#F2F3F5",
                        height: "40px",
                        width: "20%",
                      }}
                    >
                      <button
                        className="chat-button"
                        onClick={() => handleOpenPopup()}
                      >
                        <img
                          width="22px"
                          height="22px"
                          src="/img/chat/icon/fl.svg"
                          alt=""
                        />
                      </button>
                      <button className="chat-button">
                        <img
                          width="22px"
                          height="22px"
                          src="/img/chat/icon/icon.svg"
                          alt=""
                          ref={buttonEmojiRef}
                          onClick={handleTogglePicker}
                        />
                      </button>
                      <button
                        onClick={() => handleButtonClick()}
                        className="chat-button"
                      >
                        <img
                          width="22px"
                          height="22px"
                          src="/img/chat/icon/file.svg"
                          alt=""
                        />
                      </button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />
                      <button
                        className="chat-button"
                        onClick={() => sendStaffMessage()}
                      >
                        <img
                          width="22px"
                          height="22px"
                          src="/img/chat/icon/send.svg"
                          alt=""
                        />
                      </button>
                    </div>
                    {showPicker && (
                      <div
                        ref={pickerRef}
                        style={{
                          position: "fixed",
                          bottom: "100%",
                          left: pickerPosition.left,
                          top: pickerPosition.top,
                          zIndex: 1000,
                          marginBottom: "8px",
                        }}
                      >
                        <Picker
                          data={data}
                          onEmojiSelect={handleEmojiSelect}
                          previewPosition="none"
                          theme="light"
                        />
                      </div>
                    )}
                    {image && isImage && (
                      <div className="mb-2 position-relative d-inline-block">
                        <img
                          src={image}
                          alt="Preview"
                          style={{
                            maxHeight: "70px",
                            width: "100%",
                            maxWidth: "100px",
                            borderRadius: "8px",
                          }}
                        />
                        <button
                          onClick={() => {
                            setImage(null);
                            setFile(null);
                          }}
                          className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 rounded-circle"
                          style={{ width: "24px", height: "24px", padding: 0 }}
                          title="Xoá ảnh"
                        >
                          ×
                        </button>
                      </div>
                    )}
                    {image && !isImage && (
                      <div
                        className="mb-2 position-relative"
                        style={{
                          display: "flex",
                        }}
                      >
                        <div>
                          {fileType === "pdf" && (
                            <img
                              src="/img/chat/icon/pdf.svg"
                              alt="pdf"
                              width={18}
                            />
                          )}
                          {fileType === "word" && (
                            <img
                              src="/img/chat/icon/word.svg"
                              alt="word"
                              width={18}
                            />
                          )}
                          {fileType === "excel" && (
                            <img
                              src="/img/chat/icon/excel.svg"
                              alt="excel"
                              width={18}
                            />
                          )}
                          {fileType === "default" && (
                            <svg
                              className="icon"
                              width="15"
                              height="18"
                              viewBox="0 0 15 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.7259 9.47925L7.5759 14.6376C6.90074 15.2376 6.02185 15.557 5.119 15.5304C4.21615 15.5038 3.35756 15.1333 2.71888 14.4946C2.08019 13.8559 1.70966 12.9973 1.68308 12.0945C1.6565 11.1916 1.97588 10.3127 2.5759 9.63758L9.24256 2.97091C9.64058 2.59283 10.1686 2.38202 10.7176 2.38202C11.2665 2.38202 11.7945 2.59283 12.1926 2.97091C12.5804 3.3639 12.7978 3.8938 12.7978 4.44591C12.7978 4.99802 12.5804 5.52792 12.1926 5.92091L6.44256 11.6626C6.38566 11.7239 6.31724 11.7733 6.24121 11.8082C6.16519 11.843 6.08304 11.8625 5.99947 11.8656C5.9159 11.8687 5.83253 11.8553 5.75414 11.8262C5.67574 11.7971 5.60385 11.7528 5.54256 11.6959C5.48128 11.639 5.43181 11.5706 5.39696 11.4946C5.36212 11.4185 5.3426 11.3364 5.3395 11.2528C5.33641 11.1692 5.3498 11.0859 5.37892 11.0075C5.40805 10.9291 5.45232 10.8572 5.50923 10.7959L9.78423 6.52925C9.94115 6.37233 10.0293 6.1595 10.0293 5.93758C10.0293 5.71566 9.94115 5.50283 9.78423 5.34591C9.62731 5.18899 9.41448 5.10084 9.19256 5.10084C8.97065 5.10084 8.75782 5.18899 8.6009 5.34591L4.3259 9.62925C4.11199 9.8415 3.9422 10.094 3.82634 10.3722C3.71048 10.6504 3.65083 10.9487 3.65083 11.2501C3.65083 11.5514 3.71048 11.8498 3.82634 12.128C3.9422 12.4062 4.11199 12.6587 4.3259 12.8709C4.76288 13.2872 5.34324 13.5193 5.94673 13.5193C6.55022 13.5193 7.13059 13.2872 7.56756 12.8709L13.3092 7.12091C13.9716 6.41004 14.3322 5.46981 14.3151 4.4983C14.298 3.52679 13.9044 2.59987 13.2173 1.9128C12.5303 1.22574 11.6033 0.832178 10.6318 0.815037C9.66034 0.797896 8.72011 1.15851 8.00923 1.82091L1.34256 8.48758C0.443564 9.48327 -0.0365782 10.7875 0.00217603 12.1284C0.0409303 13.4693 0.595592 14.7436 1.5506 15.6857C2.5056 16.6278 3.78729 17.1651 5.12863 17.1857C6.46997 17.2062 7.76751 16.7084 8.7509 15.7959L13.9092 10.6459C13.9869 10.5682 14.0486 10.476 14.0906 10.3745C14.1327 10.2729 14.1543 10.1641 14.1543 10.0542C14.1543 9.94436 14.1327 9.83556 14.0906 9.73404C14.0486 9.63252 13.9869 9.54028 13.9092 9.46258C13.8315 9.38488 13.7393 9.32325 13.6378 9.2812C13.5363 9.23915 13.4274 9.2175 13.3176 9.2175C13.2077 9.2175 13.0989 9.23915 12.9974 9.2812C12.8958 9.32325 12.8036 9.38488 12.7259 9.46258V9.47925Z"
                                fill="#211F26"
                              />
                            </svg>
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <span
                            style={{
                              maxWidth: "600px",
                              paddingLeft: "10px",
                              display: "inline-block",
                              direction: "rtl",
                              textAlign: "left",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {_.get(file, "name", "")}
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          <button
                            onClick={() => {
                              setImage(null);
                              setFile(null);
                            }}
                            className="btn btn-sm top-0 end-0 m-1 rounded-circle"
                            style={{
                              width: "15px",
                              height: "15px",
                              padding: 0,
                            }}
                            title="Xoá ảnh"
                          >
                            x
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
          </div>
        </div>
        <div className="col-md-4 border-start h-100">
          <ChatDetail config={{ setReplyMessageId }} />
        </div>
      </div>
      <Popup
        config={{
          isOpen: isOpenShortMessage,
          onClose: closePopupShortMessage,
          position: popupPosition,
          style: {
            maxWidth: "none",
            width: popupPosition?.width ? `${popupPosition.width}px` : "500px",
          },
        }}
      >
        <div className="chat-input-action-fl bg-white border rounded-2">
          <div className="bg-gray-light px-3 py-2 d-flex gap-2 justify-content-between align-items-center"></div>
          <ul
            className="chat-contact list-group rounded-0 p-3"
            style={{
              height: "150px",
            }}
          >
            {profileShorthands.map((item) => (
              <li
                key={item.key}
                className="list-group-item list-group-item-action rounded-2 border-0 text-wrap"
                onClick={() => {
                  setText(item.text);
                  setIsOpenShortMessage(false);
                }}
              >
                <div className="d-flex gap-3 align-items-center">
                  <img
                    width="16"
                    height="16"
                    src="/img/chat/icon/fl.svg"
                    alt="icon"
                  />
                  <span className="btn bg-info-dark border-0 text-white p-0 px-2">
                    /{item.key}
                  </span>
                  <div className="small one-line one-line">{item.text}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Popup>
      <Popup
        config={{
          isOpen: isOpenBockRequester,
          onClose: closePopupBlockRequester,
          isBackground: true,
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("agent.chat.block_requester")}</h5>
          </div>
          <div className="modal-body">
            {t("agent.chat.block_requester_desc")}
          </div>
          <br />
          <div className="modal-footer gap-1">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => closePopupBlockRequester()}
            >
              {t("common.cancel")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                blockRequester();
                closePopupBlockRequester();
              }}
            >
              {t("common.yes")}
            </button>
          </div>
        </div>
      </Popup>
      <Popup
        config={{
          isOpen: isOpenServedSession,
          onClose: closePopupServedSession,
          isBackground: true,
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("agent.chat.served_session")}</h5>
          </div>
          <div className="modal-body">
            {t("agent.chat.served_session_desc")}
          </div>
          <br />
          <div className="modal-footer gap-1">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => closePopupServedSession()}
            >
              {t("common.cancel")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                servedSession();
                closePopupServedSession();
              }}
            >
              {t("common.yes")}
            </button>
          </div>
        </div>
      </Popup>
      <Popup
        config={{
          isOpen: isOpenConvertTicket,
          onClose: closePopupConvertTicket,
          isBackground: true,
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{t("agent.chat.convert_ticket")}</h5>
          </div>
          <div className="modal-body">
            {t("agent.chat.convert_ticket_desc")}
          </div>
          <br />
          <div className="modal-footer gap-1">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => closePopupConvertTicket()}
            >
              {t("common.cancel")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                convertSessionToTicket();
              }}
            >
              {t("common.yes")}
            </button>
          </div>
        </div>
      </Popup>
      <Popup
        config={{
          isOpen: isOpenAddStaff,
          onClose: closePopupAddStaff,
          isBackground: true,
        }}
      >
        <div className="modal-content" data-select2-id="select2-data-17-845o">
          <div className="modal-header">
            <h5 className="modal-title">{t("agent.chat.add_staff")}</h5>
          </div>
          <br />
          <div className="modal-body">
            <div className="row g-4">
              <div className="col-12" data-select2-id="select2-data-21-wzi4">
                <Dropdown
                  config={{
                    options: isActiveRouter ? groups : groupsAccount,
                    map: isActiveRouter
                      ? mapDropdownGroup
                      : mapDropdownGroupAccount,
                    onSelect: (option) => {
                      setGroupId(option?.value || option?._id || null);
                    },
                    placeholder: t("agent.chat.group"),
                    style: {
                      width: "100%",
                    },
                    stylePopup: {
                      maxHeight: "200px",
                    },
                    value: groupId,
                    className: "button-status",
                  }}
                />
              </div>
              <div className="col-12" data-select2-id="select2-data-21-wzi4">
                <Dropdown
                  config={{
                    options: agents,
                    map: mapConfigAgent,
                    onSelect: (option) => {
                      setAgentId(option?._id || null);
                    },
                    placeholder: t("agent.chat.staff"),
                    style: {
                      width: "100%",
                    },
                    stylePopup: {
                      maxHeight: "200px",
                    },
                    value: agentId,
                    className: "button-status",
                  }}
                />
              </div>
              <div className="col-12">
                <input
                  type="checkbox"
                  checked={isOutSession}
                  onChange={(e) => setIsOutSession(e.target.checked)}
                />
                <strong>
                  {" "}
                  {agentId
                    ? t("agent.chat.invite_and_leave")
                    : t("agent.chat.leave_chat")}
                </strong>
              </div>
              <div
                className="col-12"
                data-select2-id="select2-data-16-lqnj"
              ></div>
            </div>
          </div>
          <div className="modal-footer gap-1">
            <button
              type="button"
              className="btn btn-light"
              onClick={() => closePopupAddStaff()}
            >
              {t("common.closed")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                addStaffOtherSession();
                setIsOpenAddStaff(false);
              }}
            >
              {t("common.save")}
            </button>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default ChatPage;
